export const DOOR_TYPES = {
    SLIDING: 'sliding',
    SWING: 'swing'
};

export const DOOR_DIRECTIONS = {
    LEFT: 'left',
    RIGHT: 'right',
    BOTH: 'both'
};

export const DOOR_RENDER_PROPERTIES = {
    [DOOR_TYPES.SLIDING]: {
        color: '#2196F3',
        width: 0.9,
        height: 2.0
    },
    [DOOR_TYPES.SWING]: {
        color: '#2196F3',
        width: 0.9,
        height: 2.0
    }
};

export function Door(offset, type, direction) {
    return {
        id: `door-${Date.now()}`,
        offset,
        type,
        direction
    };
}


export function Window(offset) {
    return {
        id: `window-${Date.now()}`,
        offset,
    };
}

export const ELECTRICITY_POINT_TYPES = [
    'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'C9', 'C10',
    'C11', 'C12', 'C13', 'C14', 'C15', 'C16', 'C17', 'C18', 'C19', 'C20',
    'C21', 'C22', 'C23', 'CB1', 'CB2', 'CB4'
  ];

export function ElectricityPoint(offset, type, height) {
    return {
        id: `electricity-point-${Date.now()}`,
        offset,
        type,
        height
    };
}